<template>
    <auth-layout :snackbar="snackbar" @snackbar:close="snackbar = null">
        <div class="auth-first-connexion">
            <typo name="title-18-bold">
                {{ dico.first_connexion.title }}
            </typo>
            <template v-if="isAddingEmail">
                <sep name="S"></sep>
                <typo name="body-14-medium">
                    {{ dico.errors.first_connexion_invalid_email }}
                </typo>
            </template>
            <sep name="M" />
            <v-form class="form" ref="form" v-model="valid" @submit.prevent="submit">
                <text-field
                    required
                    placeholder="Email"
                    v-if="isAddingEmail"
                    v-model="values.newEmail"
                    :rules="[required, email]"
                />
                <text-field
                    required
                    placeholder="Email / Login"
                    v-else
                    v-model="values.loginOrEmail"
                    :rules="[required]"
                />
                <widget-captcha @captcha:done="onCaptchaDone">
                    <div class="buttons">
                        <action
                            name="main"
                            :disabled="isSubmitting || !captcha.isValid"
                            @click="submit"
                        >
                            {{ dico.first_connexion.submit_cta }}
                        </action>
                        <v-progress-circular v-if="isSubmitting" indeterminate color="primary" />
                    </div>
                </widget-captcha>
            </v-form>
            <sep name="M" />
            <router-link to="/auth">
                <typo name="body-12-normal" class="link">
                    {{ dico.first_connexion.back_cta }}
                </typo>
            </router-link>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "./AuthLayout.vue";
import TextField from "src/components/common/form/TextField.vue";
import WidgetCaptcha from "src/components/common/captcha/WidgetCaptcha.vue";
import { Services } from "src/services/Services";
import { initialAuthFormData } from "src/utils/auth-form";
import { EventBus } from "src/bus/eventBus";

export default {
    components: {
        AuthLayout,
        TextField,
        WidgetCaptcha,
    },
    data() {
        return {
            ...initialAuthFormData,
            values: {
                loginOrEmail: "",
                newEmail: "",
            },
            isAddingEmail: false,
            captcha: {
                token: null,
                isValid: false,
            },
        };
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
    },
    methods: {
        onCaptchaDone(data) {
            this.captcha = {
                token: data.captchaToken,
                isValid: data.isCaptchaValid,
            };
        },
        async submit() {
            this.isSubmitting = this.$refs.form.validate() && this.captcha.isValid;
            if (!this.isSubmitting) {
                return;
            }
            const formValues = { ...this.values, captcha: this.captcha.token };
            try {
                await Services.api.auth.handleFirstUse(formValues);
                if (this.isAddingEmail) {
                    this.snackbar = {
                        text: `Vous recevrez un mail dans quelques instants.`,
                        color: "success",
                    };
                } else {
                    this.snackbar = {
                        text: this.dico.errors["first_connexion_sent_if_email_valid"],
                        color: "success",
                    };
                }
            } catch (e) {
                if (e.payload.code === "auth/invalid-email") {
                    this.isAddingEmail = true;
                } else {
                    const errorNameByCode = {
                        "auth/has-password": "first_connexion_has_password",
                        "auth/unavailable-email": "first_connexion_non_unique_new_email",
                        "resource/not-unique": "first_connexion_non_unique_email",
                        "resource/not-found": "first_connexion_sent_if_email_valid",
                        "auth/inactive-user": "inactive_user",
                    };
                    if (e.payload.code === "resource/not-found") {
                        this.snackbar = {
                            text: this.dico.errors["first_connexion_sent_if_email_valid"],
                            color: "success",
                        };
                    } else {
                        this.snackbar = {
                            text: this.dico.errors[
                                errorNameByCode[e.payload.code] || "auth_general"
                            ],
                            color: "error",
                        };
                    }
                }
            } finally {
                this.isSubmitting = false;
                EventBus.$emit("captcha:reset");
            }
        },
    },
};
</script>

<style lang="sass" scoped>

.buttons
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: $grid-gutter
    +r(480)
        margin-top: $grid-gutter/2

.form
    width: 400px
    +r(480)
        width: 100%
</style>
